/* file gets modified via the deploy system to customize information for a particular build */

export const config = {
    build_number: '433',
    build_branch: 'production',
    build_root: '/InfoPanel/',
}



// WEBPACK FOOTER //
// ./src/config.js